module.exports = __webpack_public_path__ + "img/client-bigapple.72495969.jpeg";